import ApiConfiguration from "./ApiConfiguration";
import axios from "axios";

function withConfiguration(relativeUrl:string) {
    return ApiConfiguration.withBasePath(process.env)+relativeUrl;
}

export async function doGETRequest(relativeUrl:string) {
    let url = ApiConfiguration.withBasePath(process.env.NODE_ENV || 'local')+relativeUrl;
    const defaultHeaders = ApiConfiguration.withDefaultHeaders();
    const headers = {headers : defaultHeaders};
    var response = await axios.get(url, headers)
    .then(res => res.data)
    .catch(error => {
      var errorBody = error.response;
      return Promise.resolve(errorBody.data);
    });
    let wrappedResponse = handleResponse(response);
    console.log("WrappedResponse : " + JSON.stringify(wrappedResponse));
    return wrappedResponse;
}

export async function doPOSTRequest(relativeUrl:string, body:any) {
    const url = ApiConfiguration.withBasePath(process.env.NODE_ENV || 'local')+relativeUrl;
    const defaultHeaders = ApiConfiguration.withDefaultHeaders();
    const headers = {headers : defaultHeaders};

    var response = await axios.post(url,body,headers)
    .then(res => res.data)
    .catch(error => {
      var errorBody = error.response;
      return Promise.resolve(errorBody.data);
    });
    let wrappedResponse = handleResponse(response);
    console.log("WrappedResponse : " + JSON.stringify(wrappedResponse));
    return wrappedResponse;
}

export async function doPUTRequest(relativeUrl:string, body:any) {
    const url = ApiConfiguration.withBasePath(process.env.NODE_ENV || 'local')+relativeUrl;
    const defaultHeaders = ApiConfiguration.withDefaultHeaders();
    const headers = {headers : defaultHeaders};
    console.log("RequestBody : " + JSON.stringify(body));
    var response = await axios.put(url,body,headers)
    .then(res => res.data)
    .catch(error => {
      var errorBody = error.response;
      return Promise.resolve(errorBody.data);
    });
    let wrappedResponse = handleResponse(response);
    console.log("WrappedResponse : " + JSON.stringify(wrappedResponse));
    return wrappedResponse;
}

export async function doPATCHRequest(relativeUrl:string, body:any) {
    const url = ApiConfiguration.withBasePath(process.env.NODE_ENV || 'local')+relativeUrl;
    const defaultHeaders = ApiConfiguration.withDefaultHeaders();
    const headers = {headers : defaultHeaders};
    var response = await axios.patch(url,body,headers)
    .then(res => res.data)
    .catch(error => {
      var errorBody = error.response;
      return Promise.resolve(errorBody.data);
    });
    let wrappedResponse = handleResponse(response);
    return wrappedResponse;
}

export async function doDELETERequest(relativeUrl:string, body:any) {
    const url = ApiConfiguration.withBasePath(process.env.NODE_ENV || 'local')+relativeUrl;
    const defaultHeaders = ApiConfiguration.withDefaultHeaders();
    const config: any = { headers: defaultHeaders };
    if (body !== undefined && body !== null) {
        config.data = body;
    }
    console.log("RequestBody : " + JSON.stringify(body));
    var response = await axios.delete(url, config)
    .then(res => res.data)
    .catch(error => {
      var errorBody = error.response;
      return Promise.resolve(errorBody.data);
    });
    let wrappedResponse = handleResponse(response);
    console.log("WrappedResponse : " + JSON.stringify(wrappedResponse));
    return wrappedResponse;
}

export async function doMultipartPOSTRequest(relativeUrl:string, formData:FormData) {
    const url = ApiConfiguration.withBasePath(process.env.NODE_ENV || 'local')+relativeUrl;
    const authToken = localStorage.getItem("x-ozsk-auth-token");
    const headers = { headers: { 'x-ozsk-auth-token': authToken || "nope", 'Content-Type': 'multipart/form-data' } };
    var response = await axios.post(url, formData, headers)
    .then(res => res.data)
    .catch(error => {
      var errorBody = error.response;
      return Promise.resolve(errorBody.data);
    });
    let wrappedResponse = handleResponse(response);
    console.log("WrappedResponse : " + JSON.stringify(wrappedResponse));
    return wrappedResponse;
}

export function handleResponse(response:any) {
    if(null == response || undefined == response) {
        return {success : false, error : "Beklenmedik bir hata oluştu!"};
    }

    if(null == response.data || undefined == response.data) {
        if(null != response.error && undefined != response.error){
            const errorMsg = typeof response.error === 'object' ? response.error.message : response.error;
            return {success : false, error : errorMsg || "Beklenmedik bir hata oluştu!"};
        } else {
            return {success : false, error : "Beklenmedik bir hata oluştu!"};
        }
    }

    if(null != response.data && undefined != response.data)
    {
        return {success : true, data : response.data};
    }

    return {success : false, error : "Beklenmedik bir hata oluştu!"};
}